"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  ENTER_FIRST_NAME: 'enter_first_name',
  INVALID_FIRST_NAME: 'enter_correct_first_name',
  ENTER_LAST_NAME: 'enter_last_name',
  INVALID_LAST_NAME: 'enter_correct_last_name',
  ENTER_NAME: 'enter_name_error',
  INVALID_NAME: 'enter_correct_name',
  SHORT_NAME: 'name_is_too_short',
  LONG_NAME: 'name_is_too_long',
  ENTER_MOBILE_NUMBER: 'enter_mobile_number',
  INVALID_MOBILE_NUMBER: 'incorrect_mobile_number',
  SHORT_MOBILE_NUMBER: 'mobile_number_is_too_short',
  LONG_MOBILE_NUMBER: 'mobile_number_is_too_long',
  MOBILE_WITH_ZERO: 'mobile_number_with_zero',
  ENTER_EMAIL_ADDRESS: 'enter_email_address',
  INVALID_EMAIL_ADDRESS: 'enter_correct_email_address',
  ENTER_ID_NUMBER: 'Enter_your_ID_number',
  SHORT_ID_NUMBER: 'id_number_error_short',
  LONG_ID_NUMBER: 'id_number_error_empty_long',
  INVALID_ID_NUMBER: 'id_number_error_type',
  LONG_ID_VERSION: 'id_version_error_long_web',
  INVALID_ID_VERSION: 'id_version_number_error_type_web',
  INVALID_PASSPORT: 'invalid_passport',
  ENTER_ADDRESS: 'Enter_your_address',
  SHORT_ADDRESS: 'address_error_short',
  LONG_ADDRESS: 'address_error_long',
  ENTER_LICENSE_NUMBER: 'Enter_your_license_number',
  SHORT_LICENSE_NUMBER: 'license_error_short',
  LONG_LICENSE_NUMBER: 'license_error_long',
  INVALID_LICENSE_NUMBER: 'license_error_type',
  INVALID_LICENSE_EXPIRY: 'validation_error_license_must_valid_6_months',
  ENTER_MESSAGE: 'enter_message_error',
  ENTER_TITLE: 'enter_title_error',
  SHORT_COMPANY_NAME: 'name_is_too_short',
  SELECT_YOUR_CITY: 'select_your_city',
  ENTER_DESIGNATION: 'enter_your_designation_error'
};